module.exports = __webpack_public_path__ + "img/bill.c02196b6.png";